import { mapState } from 'vuex';

export default {
  name: 'ClientProductService',
  props: ['value', 'clientApiId'],
  data () {
    return {
      content: JSON.parse(JSON.stringify(this.value)),
      loading: false,
      checkedConfig: {}
    }
  },
  computed: {
    ...mapState(['config']),
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    groupCategories () {
      return this.$store.getters.getItemsFromConfigWithFilter('product_service_category_groups', 'deleted', false);
    },
    importContent () {
      return this.content.filter(el => el.pivot.import == 1);
    },
    manufactureContent () {
      return this.content.filter(el => el.pivot.manufacture == 1);
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content)
    },
    calculateCheckedItems () {
      const itemConfig = { };
      this.content.forEach(function (item) {
        const el = {
          import: (item.pivot.import == 1),
          manufacture: (item.pivot.manufacture == 1)
        };
        if (el.import || el.manufacture) {
          itemConfig[item.code] = el;
        }
      })
      this.checkedConfig = itemConfig;
    },
    changeChecked (code, type, value) {
      if (!this.checkedConfig[code]) {
        this.checkedConfig[code] = { import: false, manufacture: false }
      }
      this.checkedConfig[code][type] = value;
    },
    edit () {
      this.$refs['modal-window'].show();
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    save () {
      this.loading = true;
      const reqData = [];
      for (const [key, item] of Object.entries(this.checkedConfig)) {
        if (item.import == 1 || item.manufacture == 1) {
          reqData.push({
            product_service_category: key,
            manufacture: item.manufacture,
            import: item.import
          })
        }
      }
      const path = 'client/single/' + this.clientApiId + '/product-service-categories';
      const self = this;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { product_service_category: reqData }, function (response) {
        if (response.data) {
          self.content = response.data;
          self.updateValue();
          self.$emit('saved', self.content);
          self.close();
        }
        self.loading = false;
      });
    },
    getCategoryCode (catId) {
      return this.config.product_service_categories[catId].code;
    }
  },
  mounted () {
    this.calculateCheckedItems();
  }
}
